function ErrorUnauthenticated() {
    return (
        <div className="text-center">
            <h2>User not authenticated!</h2>
            <p> Please close the page and try again. </p>
        </div>
    )
}
export default ErrorUnauthenticated